import React, { PureComponent } from 'react'
import { Label } from 'atoms/Texts'
import { ButtonReg } from 'atoms/Buttons'
import {
  ModalHead,
  ModalFooter,
  ButtonSpace,
  ModalWrapper,
  ModalBody,
  InputCol,
  FieldWrapper,
  LevelRowContainer,
} from './styles'
import { withTheme } from 'styled-components'
import FormNumber from 'components/atoms/Inputs/FormNumber'
import FormTxtArea from 'components/atoms/Inputs/FormTxtArea'
import ReactSelect from 'react-select'
import { TimeInputTwoVersion } from 'components/molecules/DateTimeInput/index'
import moment from 'moment'
import { setHours, setMinutes } from 'date-fns'
import FormTxt from 'components/atoms/Inputs/FormTxt'
import { Typeahead } from '../ActualLoadingForm/styles'
import { getAllList } from 'services/cmsService'
import { GET_COAL_PILE } from 'fixtures/api'

export class DetailCoalInventoryModal extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      coalpiles: []
    }
  }

  fetchCoalPile = async () => {
    const { form, coalStockInventoryDetailsData } = this.props;

    const dataApi = await getAllList(`${GET_COAL_PILE}?companyCode=${form.companyCode}&dirLocationCode=${coalStockInventoryDetailsData.dirLocationCode.code}&areaCode=${form.areaCode.code}`)
    this.setState({
      coalpiles: dataApi
    })
  }

  renderCoalProductDetail() {
    const { coalStockInventoryDetailsData, fnChange, coalProductList, theme } =
      this.props

    const onInputChange = (e) => {
      fnChange(e, 'productCode')
    }

    return (
      <InputCol>
        <FieldWrapper>
          <Label
            lineheight={'14px'}
            size={'12px'}
          >
            Coal Product
          </Label>
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                width: '100%',
                minHeight: '34px',
                maxHeight: '34px',
                borderRadius: '6px',
                borderColor: state.isFocused
                  ? theme.getRGBA(theme.mocaPurple, 0.8)
                  : theme.mocaGrey,
                boxShadow: state.isFocused
                  ? `0px 1px 1px ${theme.getRGBA(
                      theme.blackAbs,
                      0.075
                    )} inset, 0px 1px 8px ${theme.getRGBA(
                      theme.mocaPurple,
                      0.6
                    )}`
                  : 'none',
                transition: '.2s',
                '&:hover': {
                  borderColor: state.isFocused
                    ? theme.getRGBA(theme.mocaPurple, 0.8)
                    : theme.mocaGrey,
                },
              }),
              placeholder: (base) => ({
                ...base,
                fontSize: '14px',
                color: theme.black,
              }),
              valueContainer: (base) => ({
                ...base,
                paddingTop: '0px',
                paddingBottom: '0px',
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: theme.mocaPurple,
              }),
              indicatorsContainer: (base) => ({
                ...base,
                height: '32px',
              }),
              indicatorSeparator: () => ({}),
            }}
            placeholder={'Select product'}
            getOptionValue={({ name }) => name}
            getOptionLabel={({ name }) => name}
            options={coalProductList || []}
            value={coalStockInventoryDetailsData.productCode}
            onChange={(e) => onInputChange(e)}
          />
        </FieldWrapper>
      </InputCol>
    )
  }

  renderCoalLocationDetail() {
    const {
      coalStockInventoryDetailsData,
      fnChange,
      romLocationDetails,
      theme,
      fnFetchCoalProduct,
    } = this.props

    const onInputChange = (e) => {
      fnChange(e, 'dirLocationCode')
      fnFetchCoalProduct()
      this.fetchCoalPile()
    }

    return (
      <InputCol>
        <FieldWrapper>
          <Label
            lineheight={'14px'}
            size={'12px'}
          >
            Coal Location
          </Label>
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                width: '100%',
                minHeight: '34px',
                maxHeight: '34px',
                borderRadius: '6px',
                borderColor: state.isFocused
                  ? theme.getRGBA(theme.mocaPurple, 0.8)
                  : theme.mocaGrey,
                boxShadow: state.isFocused
                  ? `0px 1px 1px ${theme.getRGBA(
                      theme.blackAbs,
                      0.075
                    )} inset, 0px 1px 8px ${theme.getRGBA(
                      theme.mocaPurple,
                      0.6
                    )}`
                  : 'none',
                transition: '.2s',
                '&:hover': {
                  borderColor: state.isFocused
                    ? theme.getRGBA(theme.mocaPurple, 0.8)
                    : theme.mocaGrey,
                },
              }),
              placeholder: (base) => ({
                ...base,
                fontSize: '14px',
                color: theme.black,
              }),
              valueContainer: (base) => ({
                ...base,
                paddingTop: '0px',
                paddingBottom: '0px',
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: theme.mocaPurple,
              }),
              indicatorsContainer: (base) => ({
                ...base,
                height: '32px',
              }),
              indicatorSeparator: () => ({}),
            }}
            placeholder={'Select location'}
            getOptionValue={({ name }) => name}
            getOptionLabel={({ name }) => name}
            options={romLocationDetails || []}
            value={coalStockInventoryDetailsData.dirLocationCode}
            onChange={(e) => onInputChange(e)}
          />
        </FieldWrapper>
      </InputCol>
    )
  }

  renderNumberInput(label, key, placeholder, inputProps) {
    const { coalStockInventoryDetailsData, fnChange, theme } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px',
    }

    const onInputChange = (e) => {
      if (key === 'volume' || key === 'factorScale') {
        const valueVolume =
          key === 'volume' ? e : coalStockInventoryDetailsData['volume']
        const valueFactorScale =
          key === 'factorScale'
            ? e
            : coalStockInventoryDetailsData['factorScale']

        const valueVolumeWithoutCommas = valueVolume
          ? valueVolume.replace(/,/g, '')
          : '0'
        const valueFactorScaleWithoutCommas = valueFactorScale
          ? valueFactorScale.replace(/,/g, '')
          : '0'

        const parsedValueVolume =
          valueVolumeWithoutCommas === '0'
            ? 0
            : valueVolumeWithoutCommas.endsWith('.')
            ? valueVolumeWithoutCommas
            : parseFloat(valueVolumeWithoutCommas)
        const parsedValueFactorScale =
          valueFactorScaleWithoutCommas === '0'
            ? 0
            : valueFactorScaleWithoutCommas.endsWith('.')
            ? valueFactorScaleWithoutCommas
            : parseFloat(valueFactorScaleWithoutCommas)

        if (
          typeof parsedValueFactorScale !== 'string' &&
          typeof parsedValueVolume !== 'string'
        ) {
          const total = parsedValueVolume * parsedValueFactorScale

          let formattedValueTotal =
            total === ''
              ? '0'
              : total.toString().endsWith('.')
              ? new Intl.NumberFormat('en-US').format(total) + '.'
              : new Intl.NumberFormat('en-US', {
                  maximumFractionDigits: 4,
                }).format(total)

          fnChange(formattedValueTotal, 'tonnage')
        }
      }

      fnChange(e, key)
    }

    return (
      <InputCol>
        <FieldWrapper>
          <Label
            lineheight={'14px'}
            size={'12px'}
          >
            {label}
          </Label>
          <FormNumber
            placeholder={placeholder}
            value={coalStockInventoryDetailsData[key]}
            onChangeVal={(e) => onInputChange(e)}
            isDecimal
            fractionDigits={4}
            {...inputConfig}
            {...inputProps}
          />
        </FieldWrapper>
      </InputCol>
    )
  }

  renderTextInput(label, key, placeholder, inputProps) {
    const { coalStockInventoryDetailsData, fnChange } = this.props
    const onInputChange = (e) => {
      fnChange(e, key)
    }

    return (
      <InputCol>
        <FieldWrapper>
          <Label
            lineheight={'14px'}
            size={'12px'}
          >
            {label}
          </Label>
          <FormTxt
            placeholder={placeholder}
            mb={'16px'}
            width="100%"
            style={{
              borderColor: '#AFAFB9',
              height: '34px',
              marginBottom: '0px',
            }}
            value={coalStockInventoryDetailsData[key]}
            onChangeVal={(e) => onInputChange(e.target.value)}
            {...inputProps}
          />
        </FieldWrapper>
      </InputCol>
    )
  }

  renderTextAreaInput(label, key, placeholder, inputProps) {
    const { coalStockInventoryDetailsData, fnChange } = this.props
    const onInputChange = (e) => {
      fnChange(e, key)
    }

    return (
      <InputCol>
        <FieldWrapper>
          <Label
            lineheight={'14px'}
            size={'12px'}
          >
            {label}
          </Label>
          <FormTxtArea
            placeholder={placeholder}
            rows="5"
            mb={'16px'}
            width="100%"
            style={{ borderColor: '#AFAFB9' }}
            value={coalStockInventoryDetailsData[key]}
            onChangeVal={(e) => onInputChange(e.target.value)}
            {...inputProps}
          />
        </FieldWrapper>
      </InputCol>
    )
  }

  renderTimeInput(label, key, disabled, minTime, maxTime) {
    const { coalStockInventoryDetailsData, fnChange, theme } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px',
    }

    return (
      <InputCol>
        <FieldWrapper>
          <Label
            lineheight={'14px'}
            size={'12px'}
          >
            {label}
          </Label>
          <TimeInputTwoVersion
            val={
              coalStockInventoryDetailsData[key] &&
              new Date(coalStockInventoryDetailsData[key])
            }
            fn={(date, field) => fnChange(moment(date).format(), field)}
            field={key}
            config={inputConfig}
            disabled={disabled}
            minTime={minTime}
            maxTime={maxTime}
          />
        </FieldWrapper>
      </InputCol>
    )
  }

  renderPileNo(){
      const { fnChange, coalStockInventoryDetailsData } = this.props
      const { coalpiles } = this.state
  
      const onSelect = (val) => {
        if (val) {
          fnChange(val, 'coalpile')
        }
      }
      const onInputChange = (e) => {
        fnChange(e, 'coalpile')
      }
      const onClear = () => {
        fnChange('', 'coalpile')
      }

      return <InputCol>
        <Label lineheight={'14px'} size={'12px'}>
          Pile No/Name
        </Label>
        <Typeahead
          placeholder={'Select pile no'}
          options={coalpiles}
          dispField={'name'}
          control={coalStockInventoryDetailsData.coalpile ? [coalStockInventoryDetailsData.coalpile] : []}
          onChangeVal={e => onSelect(e)}
          onInputChange={e => onInputChange(e)}
          onClearSelect={onClear}
        />
      </InputCol>
    }

  render() {
    const { form, fnSwitch, fnOnSubmit, coalStockInventoryDetailsData } =
      this.props
    const isSurveyDateToday =
      form['surveyDate'] && moment(form['surveyDate']).isSame(moment(), 'day')
    const minTimeStart = setHours(setMinutes(new Date(), 0), 0)
    const startTimeDate = new Date(coalStockInventoryDetailsData['startTime'])
    const minTimeEnd = coalStockInventoryDetailsData['startTime']
      ? startTimeDate.setMinutes(startTimeDate.getMinutes() + 1)
      : setHours(setMinutes(new Date(), 0), 0)
    const maxTime = isSurveyDateToday
      ? new Date()
      : setHours(setMinutes(new Date(), 59), 23)

    return (
      <ModalWrapper>
        <ModalHead>
          <Label
            lineheight={'29px'}
            size={'24px'}
            mb={'0px'}
          >
            Detail Coal Inventory
          </Label>
        </ModalHead>
        <ModalBody>
          <LevelRowContainer>
            {this.renderCoalLocationDetail()}
            {this.renderPileNo()}
          </LevelRowContainer>
          <LevelRowContainer>
          {this.renderCoalProductDetail()}
            {this.renderNumberInput('Volume', 'volume', 'Enter volume')}
          </LevelRowContainer>
          <LevelRowContainer>
            {this.renderNumberInput(
              'Factor Scale',
              'factorScale',
              'Enter factor scale'
            )}
            {this.renderNumberInput('Tonnage', 'tonnage', 'Enter tonnage')}
          </LevelRowContainer>
          <LevelRowContainer>
            {this.renderTimeInput(
              'Start Time',
              'startTime',
              !form['surveyDate'],
              minTimeStart,
              maxTime
            )}
            {this.renderTimeInput(
              'End Time',
              'endTime',
              !coalStockInventoryDetailsData['startTime'],
              minTimeEnd,
              maxTime
            )}
          </LevelRowContainer>
          <LevelRowContainer>
            {this.renderTextAreaInput('Remark', 'remark', 'Enter remark')}
          </LevelRowContainer>
        </ModalBody>
        <ModalFooter>
          <ButtonSpace>
            <ButtonReg
              btnTxt={'OK'}
              onClick={() => fnOnSubmit(coalStockInventoryDetailsData)}
            />
          </ButtonSpace>
          <ButtonSpace>
            <ButtonReg
              btnTxt={'Cancel'}
              onClick={() => fnSwitch()}
            />
          </ButtonSpace>
        </ModalFooter>
      </ModalWrapper>
    )
  }
}

export default withTheme(DetailCoalInventoryModal)
